<template>
  <Container>
    <template #header>
      <Text pattern="body2" :weight="600" height="135%">EMCD NEWS</Text>
    </template>
    <template #body>
      <div key="news_content" class="news_content">
        <div class="news_item" v-for="item in data" :key="item.key">
          <Text pattern="body2" :weight="600">
            {{ item.title }}
          </Text>
          <Text pattern="body3" :weight="500" color="#979797">
            {{ item.subtitle }}
          </Text>
          <Text pattern="body3" :weight="500" color="#2D2D2D">
            {{ item.time }}
          </Text>
        </div>
      </div>
      <BaseButton type="cta" size="sm" strokeSecondary class="news_button">
        {{ $t("Explore daily digest") }}
      </BaseButton>
    </template>
  </Container>
</template>

<script>
import { Text, BaseButton, Container } from "@/shared/ui";

export default {
  name: "News",
  components: { Text, BaseButton, Container },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  &_content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
  }

  &_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &_button {
    align-self: left;
    margin-top: 20px;
    width: max-content;
  }
}
</style>
